var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "chat", staticClass: "chat", attrs: { tabindex: "-1" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.channel.moreHistoryAvailable,
              expression: "channel.moreHistoryAvailable",
            },
          ],
          staticClass: "show-more",
        },
        [
          _c(
            "button",
            {
              ref: "loadMoreButton",
              staticClass: "btn",
              attrs: {
                disabled:
                  _vm.channel.historyLoading || !_vm.$store.state.isConnected,
              },
              on: { click: _vm.onShowMoreClick },
            },
            [
              _vm.channel.historyLoading
                ? _c("span", [_vm._v("Loading…")])
                : _c("span", [_vm._v("Shiko mesazhet e vjetra")]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "messages",
          attrs: {
            role: "log",
            "aria-live": "polite",
            "aria-relevant": "additions",
          },
          on: { copy: _vm.onCopy },
        },
        [
          _vm._l(_vm.condensedMessages, function (message, id) {
            return [
              _vm.shouldDisplayDateMarker(message, id)
                ? _c("DateMarker", {
                    key: message.id + "-date",
                    attrs: {
                      message: message,
                      focused: message.id == _vm.focused,
                    },
                  })
                : _vm._e(),
              _vm.shouldDisplayUnreadMarker(message.id)
                ? _c(
                    "div",
                    {
                      key: message.id + "-unread",
                      staticClass: "unread-marker",
                    },
                    [_c("span", { staticClass: "unread-marker-text" })]
                  )
                : _vm._e(),
              message.type === "condensed"
                ? _c("MessageCondensed", {
                    key: message.messages[0].id,
                    attrs: {
                      network: _vm.network,
                      "keep-scroll-position": _vm.keepScrollPosition,
                      messages: message.messages,
                      focused: message.id == _vm.focused,
                    },
                  })
                : _c("Message", {
                    key: message.id,
                    attrs: {
                      channel: _vm.channel,
                      network: _vm.network,
                      message: message,
                      "keep-scroll-position": _vm.keepScrollPosition,
                      "is-previous-source": _vm.isPreviousSource(message, id),
                      focused: message.id == _vm.focused,
                    },
                    on: { "toggle-link-preview": _vm.onLinkPreviewToggle },
                  }),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }